import {Injectable} from '@angular/core';
import {QueryEntity} from '@datorama/akita';
import {PopupState, Store} from './store';

@Injectable({ providedIn: 'root' })
export class PopupQuery extends QueryEntity<PopupState> {

  constructor(protected store: Store) {
    super(store);
  }

}
